// // import { pushState } from 'redux-react-router';
import Cookies from 'js-cookie';

export default function auth({ dispatch, getState }) {
  return next => action => {
    const result = next(action);
    // if (result && result.error && result.error.json && result.error.json.code === 403) {
    //   debugger;
    //   return;
    // }
    if (
      result &&
      result.error &&
      result.error.json &&
      result.error.json.code === 401
    ) {
      Cookies.remove('accessToken');
      dispatch({ type: 'CLEAR_ACCESS_TOKEN' });
      dispatch({ type: '401' });
    }
    // dispatch(pushState(null, '/login')); // observer will take care of redirecting back to /login
    return result;
  };
}



// WEBPACK FOOTER //
// ./src/middleware/auth.js